var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SOSlotModal',{attrs:{"modal-id":_vm.modalId,"modal-title":_vm.getTitle},on:{"close":_vm.back},scopedSlots:_vm._u([{key:"modal-body",fn:function(){return [_c('div',{staticClass:"message-wrapper"},[_c('div',{staticClass:"msg msg-body f-14",domProps:{"innerHTML":_vm._s(_vm.getMessage)}})])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }